import { Link } from "react-router-dom";
import { KeyRound, Mail, Globe } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-night text-linen/80">
      <div className="max-w-7xl mx-auto px-5 sm:px-10 py-16 sm:py-20">
        <p className="font-serif text-lg sm:text-xl text-linen/75 text-center max-w-3xl mx-auto leading-relaxed mb-14 sm:mb-16" data-testid="footer-mission">
          Individually created watercolor notecards that capture the beauty of the fields, valleys, lakes, streams and ocean shores of the Pacific Northwest.
        </p>
        <div className="grid gap-12 md:grid-cols-3">
        <div>
          <p className="font-serif text-2xl text-linen">Artist&rsquo;s Studio Gallery</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-linen/50 mt-2">Richard Kuensting — Landscape Painter</p>
          <p className="text-sm leading-relaxed text-linen/60 mt-5 max-w-xs">
            Painted slowly, in natural light — the Willamette Valley, Oregon.
          </p>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-ochre mb-5">Explore</p>
          <ul className="space-y-3 text-sm">
            <li><Link to="/notecards" className="hover:text-ochre transition-colors">Notecards Shop</Link></li>
            <li><Link to="/about" className="hover:text-ochre transition-colors">About the Studio</Link></li>
            <li><Link to="/contact" className="hover:text-ochre transition-colors">Contact &amp; Commissions</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-ochre mb-5">The Studio</p>
          <ul className="space-y-3 text-sm text-linen/70">
            <li className="flex items-center gap-2"><Mail size={14} className="text-ochre" /> r.kuensting@gmail.com</li>
            <li className="flex items-center gap-2"><Globe size={14} className="text-ochre" /> artistsstudiogallery.com</li>
          </ul>
        </div>
        </div>
      </div>
      <div className="border-t border-linen/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-10 py-6 flex flex-wrap items-center justify-between gap-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-linen/40">
            © {new Date().getFullYear()} Richard Kuensting — All artworks original
          </p>
          <Link to="/studio" data-testid="admin-link"
            className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-linen/40 hover:text-ochre transition-colors">
            <KeyRound size={12} /> Studio Entrance
          </Link>
        </div>
      </div>
    </footer>
  );
}
